export const INBOUND = 'inbound'
export const OUTBOUND = 'outbound'
export const RETURN = 'return'
export const ONEWAY = 'oneway'

export const TYPE_AIRPORT = 'A'
export const TYPE_CITY = 'C'

export const QUERY_PARAMS = [
  'originCode',
  'originType',
  'origin_type',
  'destinCode',
  'destinType',
  'destin_type',
  'origin',
  'destin',
  'numAdt',
  'numadt',
  'numChd',
  'numchd',
  'numInf',
  'numinf',
  'numYth',
  'numyth',
  'tripType',
  'sref',
  'upsltab'
] as const
